module.exports = __webpack_public_path__ + "media/softinyalms-az.1e019b58.mp4";